import { useTranslation } from 'react-i18next';

const useRoutes = () => {
  const { t } = useTranslation();

  const routes = [
    {
      name: 'login',
      route: '/login',
    },

    {
      name: t('header.sales'),
      route: '/salgs',
    },
    {
      name: t('header.lastCardTransactions'),
      route: '/kort-transaksjoner',
    },
    {
      name: t('header.recent'),
      route: '/siste-salgs',
    },
    {
      name: t('header.lastTransactions'),
      route: '/siste-transaksjoner',
    },
    {
      name: t('header.ticketList'),
      route: '/billett-liste',
    },

    {
      name: t('header.ticketHistoric'),
      route: '/billet-historikk',
    },
    {
      name: t('header.gameplan'),
      route: '/spillplan',
    },

    /*
    {
      name: t('header.endShift'),
      route: '/avslutte-skiftet',
    },
    */
  ];

  return routes;
};

export default useRoutes;
